import { object, string } from 'yup';

const personSchema = object({
  firstName: string().required(),
  lastName: string().required(),
});

export default personSchema;
